import request from './services/axios.js'
export default {
  findSubscribeRecordOrderByPage: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadSubscribeRecord/findSubscribeRecordOrderByPage',
      method: 'get'
    })
  },
  findInvoiceByPage: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadInvoice/findUserApplyInvoiceRecordByPage',
      method: 'get'
    })
  },
  getInvoiceOrderPage: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadOrder/getInvoiceOrderPage',
      method: 'get'
    })
  },
  updateInvoiceStatus: (id) => {
    return request({
      url: '/ebook/cloudReadInvoice/updateInvoiceStatus?id=' + id,
      method: 'post'
    })
  },
  findpublishUnitInvoiceManageByPage: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadInvoice/findpublishUnitInvoiceManageByPage',
      method: 'get'
    })
  },
  applyInvoice: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadInvoice/applyInvoice',
      method: 'post'
    })
  },
  getAddressList: (params) => {
    return request({
      params,
      url: '/user/addressList.do',
      method: 'get'
    })
  },
  addressSave: (params) => {
    return request({
      params,
      url: '/user/addressSave.do',
      method: 'post'
    })
  }
}
